/**
 * Represents the data that is sent with the event.
 * Should be implemented and extended to keep consumers in mind.
 */
export interface CrossAppEventData {
    contractId?: string;
    customerId?: string;
    contactId?: string;
    id?: string;
    type?: string;
    name?: string;
}
